let language = {
    REGIST_PARTNER_VERIFY_TIP_TITLE_TEXT: "验证您的电子邮箱",
    REGIST_PARTNER_VERIFY_TIP_HINTONE_TEXT: "你快到了 ！我们发送了一封电子邮件至",
    REGIST_PARTNER_VERIFY_TIP_HINTTWO_TEXT: "只需点击该电子邮件中的链接即可完成注册。如果您没有看到它，您可能需要检查您的垃圾邮件文件夹",
    
    REGIST_PARTNER_VERIFY_TIP_RESEND_MAIL_TEXT: "重新发送验证邮件",
    REGIST_PARTNER_VERIFY_TIP_OK_TEXT: "确认",
  
};

export { language }